<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0">Уведомления</h4>
					<div class="page-title-right">
						<ol class="breadcrumb m-0">
							<li class="breadcrumb-item">
								<router-link :to="{path: '/'}">Главная</router-link>
							</li>
							<li class="breadcrumb-item active">Уведомления</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex align-items-center justify-content-between">
					<h5>Новые</h5>
					<a href="#" class="btn btn-sm btn-info">Отметить все как прочитанное</a>
				</div>
				<div data-simplebar>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<div class="avatar-xs">
									<span class="avatar-title bg-primary rounded-circle font-size-16">
										<i class="uil-shopping-basket"></i>
									</span>
								</div>
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Ваш заказ размещен</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Если несколько языков объединяют грамматику</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 минуты назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<img src="assets/images/users/avatar-3.jpg" class="rounded-circle avatar-xs" alt="user-pic" />
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Иван Иванов</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Это будет выглядеть как упрощенный английский.</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 час назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<div class="avatar-xs">
									<span class="avatar-title bg-success rounded-circle font-size-16">
										<i class="uil-truck"></i>
									</span>
								</div>
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Ваш заказ отправлен</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Если несколько языков объединяют грамматику</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 минуты назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<img src="assets/images/users/avatar-4.jpg" class="rounded-circle avatar-xs" alt="user-pic" />
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Селена Лэйфильд</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Как скептически настроенный кембриджский друг, мой западный.</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 час назад</p>
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<div class="d-flex align-items-center justify-content-between">
					<h5>Прочитанные</h5>
					<a href="#" class="btn btn-sm btn-danger">Удалить все прочитанные</a>
				</div>
				<div data-simplebar>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<div class="avatar-xs">
									<span class="avatar-title bg-primary rounded-circle font-size-16">
										<i class="uil-shopping-basket"></i>
									</span>
								</div>
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Ваш заказ размещен</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Если несколько языков объединяют грамматику</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 минуты назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<img src="assets/images/users/avatar-3.jpg" class="rounded-circle avatar-xs" alt="user-pic" />
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Иван Иванов</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Это будет выглядеть как упрощенный английский.</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 час назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<div class="avatar-xs">
									<span class="avatar-title bg-success rounded-circle font-size-16">
										<i class="uil-truck"></i>
									</span>
								</div>
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Ваш заказ отправлен</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Если несколько языков объединяют грамматику</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 минуты назад</p>
								</div>
							</div>
						</div>
					</a>
					<a href="javascript:void(0);" class="text-reset notification-item">
						<div class="d-flex align-items-start">
							<div class="flex-shrink-0 me-3">
								<img src="assets/images/users/avatar-4.jpg" class="rounded-circle avatar-xs" alt="user-pic" />
							</div>
							<div class="flex-grow-1">
								<h6 class="mb-1">Селена Лэйфильд</h6>
								<div class="font-size-12 text-muted">
									<p class="mb-1">Как скептически настроенный кембриджский друг, мой западный.</p>
									<p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 час назад</p>
								</div>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'Notifications',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Уведомления | Krasp'});
	},
	data: () => ({
		
	}),
	methods: {
		
	},
	beforeMount(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	computed: {},
	components: {
		//Navbar,
	},
};
</script>